import { createTheme } from '@one-thd/sui-atomic-components';

const SummerPrimaryYellow = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

SummerPrimaryYellow.palette['--sui-palette-background-primary'] = '255 212 64';

export { SummerPrimaryYellow };
